import { createSlice } from '@reduxjs/toolkit';

interface AdjustStoreProps {
    changeData:  any[],
}

export const adjustmentSliceForSnap = createSlice({
    name: 'adjustmentForSnap',
    initialState: {
        payload: {
            changeData: [],
        } as AdjustStoreProps
    },
    reducers: {
        saveChangeData: (state, action) => {
            state.payload.changeData = action.payload.changeData;
        },
    }
});

export const { saveChangeData } = adjustmentSliceForSnap.actions;

export default adjustmentSliceForSnap.reducer;